import logoutPlaceholder from '../../hooks/logoutPlaceholder.js';

const apiEndPoint = process.env.REACT_APP_FETCH_URL;

export const getPageContentByUrn = async ({ urn, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/page/${urn}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            const parsed = await response.json();
            if(parsed.page) {
                return parsed;
            }
            return null;
        }
        catch (error) {
            throw new Error(`Failed lading page content: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load page content: ${response.statusText}`);
};

export const getPageContentByIndex = async ({ id, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/index/${id}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            const parsed = await response.json();
            if(parsed.page) {
                return parsed;
            }
            return null;
        }
        catch (error) {
            throw new Error(`Failed lading page content: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load page content: ${response.statusText}`);
};

export const resolveUrns = async ({ indexes, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/resolveUrns`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        mode: "cors",
        credentials: "include",
        body: JSON.stringify({ indexes })
    });
    if(response.ok) {
        try {
            const parsed = await response.json();
            return parsed.pages ?? [];
        }
        catch (error) {
            throw new Error(`Failed parsing resolved page urns: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not resolve page urns: ${response.statusText}`);
};

export const getPagePreviewContentByIndex = async ({ id }) => {
    const response = await fetch(`${apiEndPoint}/api/author/page/content/${id}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            const parsed = await response.json();
            if(parsed.page) {
                return parsed;
            }
            return null;
        }
        catch (error) {
            throw new Error(`Failed lading page content: ${error}`);
        }
    }
    throw new Error(`Could not load page content: ${response.statusText}`);
};

export const getCount = async ({ categoryKey = null, categoryValue = null, logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/live/${(categoryKey && categoryValue) ? `categoryCount?categoryKey=${categoryKey}&categoryValue=${categoryValue}` : "count"}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing the list of pages with details: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load the list of pages with details: ${response.statusText}`);
};

/* Filters by any number of page properties at once, matching `data` keys as configured through extraPageFields.
 * `filterGroups` is an array of AND'd-together OR-groups - e.g. [{key:"category",value:"insights"}] AND's a
 * single clause in, while [[{key:"category",value:"a"},{key:"category",value:"b"}]] OR's "a"/"b" together.
 * `search` is a plain full-text term, matched across title/content/abstract and AND'd with `filterGroups`. */
export const listInfo = async ({
    skip = 0,
    limit = 1,
    order = "asc",
    sort = null,
    filterGroups = [],
    search = "",
    deep = true,
    includeContent = false,
    logout = logoutPlaceholder
}) => {
    const query = new URLSearchParams({ skip, limit, order, deep: String(deep), includeContent: String(includeContent) });
    sort && query.set("sort", sort);
    search && query.set("search", search);
    filterGroups.length && query.set("filters", JSON.stringify(filterGroups));

    const response = await fetch(`${apiEndPoint}/api/live/listInfo?${query.toString()}`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing the list of pages with details: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load the list of pages with details: ${response.statusText}`);
};
